import { Observable } from "rxjs";
import { UseCase } from "../../../../core/use-case";
import { ProfessionalFigure } from "../../../models/agreement.model";
import { HrRepository } from "../../../repositories/hr.repository";

export class GetAllFigureUseCase
  implements UseCase<void, ProfessionalFigure[]>
{
  constructor(private repo: HrRepository) {}
  execute(param: void): Observable<ProfessionalFigure[]> {
    return this.repo.getAllProfessionalFigure();
  }
}

const getAllFigureUseCaseFactory = (repo: HrRepository) =>
  new GetAllFigureUseCase(repo);

export const getAllProfessionalFigureProvider = {
  provide: GetAllFigureUseCase,
  useFactory: getAllFigureUseCaseFactory,
  deps: [HrRepository],
};
